<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="富足时刻配置" @back="goBack" /></span>
        </div>

        <el-table :data="formData" border stripe>
          <!--          <el-table-column prop="buyNum" label="限制次数">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-select v-model.number="scope.row.type" placeholder="请选择" @change="listenType">-->
          <!--                <el-option-->
          <!--                  v-for="item in types"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value"-->
          <!--                  :disabled="item.disabled"-->
          <!--                />-->
          <!--              </el-select>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="bet" label="倍数" width="400px">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.bet" placeholder="倍数" />
            </template>
          </el-table-column>
          <!--          <el-table-column prop="bet" label="倍数">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button v-permisaction="['config:RewardCoinBlastEdit:del']" type="danger" @click="del(scope.$index)">删除</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
        <el-button v-if="formData.length <= 0" v-permisaction="['config:RewardCoinBlastEdit:add']" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:RewardCoinBlastEdit:add']" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyStageRewardCfg,
  updateActivtyStageRewardCfg
} from '@/api/config/activity-cfg'
import { getChessBoardType } from '@/api/config/slot'

export default {
  name: 'RewardCoinBlastEdit',
  data() {
    return {
      isOnline: 0,
      aid: 0,
      type: '',
      types: [],
      exactArr: [1, 3, 13, 15, 18, 17, 21, 22, 6, 7, 8, 9, 10, 11, 12],
      formData: [{ bet: 0 }]
    }
  },
  created() {
    this.getChessBoardType()
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const obj = { bet: this.formData[0].bet }
      const postData = { type: this.type, aid: this.aid, reward: obj }
      const data = JSON.stringify(postData)
      // console.log(data)
      updateActivtyStageRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(actName) {
      this.formData = []
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          if (!res.data.reward) {
            this.formData.push({ bet: 0 })
          } else {
            this.formData.push(res.data.reward)
          }
          this.listenType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.listenType()
      let selectType = ''
      this.types.forEach(item => {
        if (!item.disabled) {
          selectType = item.value
        }
      })

      if (!selectType) {
        this.msgError('无可添加类型')
        return
      }
      // console.log('可选类型', selectType)
      this.formData.push({ bet: 1 })
      this.listenType()
    },
    del(i) {
      this.formData = this.formData.filter((item, index) => {
        return index !== i
      })
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            var id = parseInt(i)
            if (!this.exactArr.includes(id)) {
              this.types.push({ 'label': res.data[i], 'value': id, disabled: false })
            }
          }

          this.types.push({ 'label': '打', 'value': 1, disabled: false })
          this.types.push({ 'label': '偷', 'value': 2, disabled: false })
        }
      })
    },
    listenType() {
      this.types.forEach((item, index) => {
        this.types[index].disabled = false
      })
      this.formData.forEach((item, index) => {
        for (const i in this.types) {
          const t = this.types[i]
          if (t.value === item.type) {
            this.types[i].disabled = true
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
